/**
 * @file paddle 贡献指南
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import request from 'superagent';
import baseRequest from '../baseApiText';

export const getContributionInfo = (params: any): Promise<request.Response> =>
    baseRequest(
        request.get(`/documentation/docs/zh/guides/10_contribution/${params}.html`)
            .query({ raw: 'true', reviewVersion: 'jenkins-doc-review-2-233' })
    );